"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminInvariantViolation = void 0;
const domain_error_js_1 = require("./domain-error.js");
/**
 * Thrown when an operation would leave a tenant with zero admins.
 * Per Decision P: ≥1 admin per tenant is a system invariant enforced
 * at the AdminService layer inside a transaction.
 *
 * Phase 3 ships this type so Phase 5 can throw it without a schema change.
 * No enforcement logic exists yet — only the error type.
 */
class AdminInvariantViolation extends domain_error_js_1.DomainError {
    constructor(message = 'Operation would leave the tenant with no admins', cause) {
        super(message, 'ADMIN_INVARIANT_VIOLATION', cause);
    }
}
exports.AdminInvariantViolation = AdminInvariantViolation;
//# sourceMappingURL=admin-invariant-violation.js.map